export default __webpack_public_path__ + "static/media/eth.c6e33228.svg";